import Ember from 'ember';
export const isDestroying = Ember._isDestroying;
export const isDestroyed = Ember._isDestroyed;